import type { User } from "@eai-toolkit/client";
import { useMemo } from "react";

import { useGetUsersQuery } from "../api/usersApi";

export function useUsersWithMap() {
  const queryResult = useGetUsersQuery();

  const usersList = useMemo(() => queryResult.data ?? [], [queryResult.data]);

  const usersMap = useMemo(() => {
    const map = new Map<string, User>();
    usersList.forEach((user) => {
      map.set(user.id, user);
      if (user.fullName) {
        map.set(user.fullName, user);
      }
    });
    return map;
  }, [usersList]);

  return {
    ...queryResult,
    usersList,
    usersMap,
  };
}
